// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ResearchInterestTags-cls1__f934242d701b63ef72df{/*!*/}.ResearchInterestTags-cls2__a67be5543f66dee3c483{text-align:right;padding:5px;font-size:12px;height:25px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ResearchInterestTags-cls1__f934242d701b63ef72df",
	"cls2": "ResearchInterestTags-cls2__a67be5543f66dee3c483 ResearchInterestTags-cls1__f934242d701b63ef72df"
};
export default ___CSS_LOADER_EXPORT___;
